module.exports = __webpack_public_path__ + "img/VehiculoDatos.dc12894e.svg";